import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { states, financingTypes } from '../contacts-lookups';
import { ContactsService } from '../contacts.service';

@Component({
  selector: 'no-access-popup',
  templateUrl: './no-access-popup.component.html',
  styleUrls: ['./no-access-popup.component.scss'],
})
export class NoAccessPopup implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NoAccessPopup>,
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  openCalendly() {
    (<any>window).Calendly.showPopupWidget(
      'https://calendly.com/mashvisor/demo/?utm_source=Mashboard&utm_medium=Mashboard&utm_campaign=Mashboard&utm_term=Mashboard',
    );
  }
}
